import { createSlice } from "@reduxjs/toolkit";

const existingSession = JSON.parse(localStorage.getItem("hub-app-session"));
const init = { token: "", email: "", name: "", permissions: [], exp: "" };

const authSlice = createSlice({
  name: "auth",
  initialState: existingSession || init, //Restore session from local storage if exists
  reducers: {
    setSession (state, action) {
      // Save to localStorage when session is set
      localStorage.setItem("hub-app-session", JSON.stringify(action.payload));
      return {...action.payload}
    },

    logout () {
      localStorage.removeItem("hub-app-session");
      sessionStorage.setItem("hub-app-logged-out", "true");
      
      return {...init} //reset the auth state
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
